module.exports = __webpack_public_path__ + "media/images/landing/bg/sprites-retina-d510ac00d65bf028fe48637fc98c2882.png";